package prescription.containers

import com.jingfangpai.api.clients.CommentApiClient
import com.jingfangpai.api.clients.MedicineApiClient
import com.jingfangpai.api.clients.PrescriptionApiClient
import com.jingfangpai.common.data.response.ApiResponse
import com.jingfangpai.common.orm.mapping.Comment
import com.jingfangpai.common.orm.mapping.enums.CommentEntityType
import com.jingfangpai.common.orm.mapping.enums.CommentType
import com.jingfangpai.common.orm.mapping.Prescription
import com.jingfangpai.prescription.model.PrescriptionDetail
import prescription.components.PrescriptionInDetail
import react.*
import react.dom.div
import setTitle

external interface PrescriptionDetailPageProps : RProps {
    var id: String
}

data class PrescriptionDetailPageContextData(
    var getDetail: (id: String, okCallback: (result: ApiResponse<PrescriptionDetail>) -> Unit, errorCallback: (exception: Throwable) -> Unit) -> Unit,
    var getComments: (entityType: CommentEntityType, entityId: String, type: CommentType, okCallback: (result: ApiResponse<Array<Comment>>) -> Unit, errorCallback: (exception: Throwable) -> Unit) -> Unit,
    var saveComment: (comment: Comment, okCallback: (result: ApiResponse<Comment>) -> Unit, errorCallback: (exception: Throwable) -> Unit) -> Unit,
    var getMedicineIdNames: (okCallback: (result: ApiResponse<List<com.jingfangpai.common.data.model.IdName>>) -> Unit, errorCallback: (exception: Throwable) -> Unit) -> Unit
)

val PrescriptionDetailPageContext = createContext(PrescriptionDetailPageContextData(PrescriptionApiClient::getDetail, CommentApiClient::getComments, CommentApiClient::save, MedicineApiClient::getIdNameList))

val PrescriptionDetailPageProvider = functionalComponent<PrescriptionDetailPageProps> { props ->

    setTitle("方剂")

    useEffectOnce { }

    PrescriptionDetailPageContext.Provider(PrescriptionDetailPageContextData(PrescriptionApiClient::getDetail, CommentApiClient::getComments, CommentApiClient::save, MedicineApiClient::getIdNameList)) {
        div("PrescriptionDetailPage-page") {
            child(PrescriptionInDetail) {
                attrs {
                    id = props.id
                }
            }
        }
    }
}
